import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppBar, Box, Toolbar, Button, Container, useScrollTrigger, Slide } from '@mui/material';
import Logo from './Logo';

const HideOnScroll = ({ children }) => {
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const Navbar = () => {
  const navigate = useNavigate();
  const [isAuthenticated] = useState(false); // Replace with actual auth state

  return (
    <HideOnScroll>
      <AppBar 
        position="fixed" 
        elevation={0}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(8px)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1,
            }}
          >
            <Link to="/" style={{ textDecoration: 'none' }}>
              <Logo />
            </Link>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              {!isAuthenticated ? (
                <>
                  <Button
                    component={Link}
                    to="/login"
                    variant="text"
                    color="primary"
                    sx={{
                      fontWeight: 600,
                      '&:hover': {
                        backgroundColor: 'rgba(37, 99, 235, 0.04)',
                      },
                    }}
                  >
                    Log In
                  </Button>
                  <Button
                    component={Link}
                    to="/register"
                    variant="contained"
                    color="primary"
                    sx={{
                      fontWeight: 600,
                      borderRadius: '50px',
                      px: 3,
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(37, 99, 235, 0.15)',
                      },
                      transition: 'all 0.2s ease-in-out',
                    }}
                  >
                    Get Started
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    component={Link}
                    to="/dashboard"
                    variant="text"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Dashboard
                  </Button>
                  <Button
                    component={Link}
                    to="/profile"
                    variant="text"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Profile
                  </Button>
                  <Button
                    onClick={() => {
                      // Handle logout
                      navigate('/');
                    }}
                    variant="outlined"
                    color="primary"
                    sx={{
                      fontWeight: 600,
                      borderRadius: '50px',
                      '&:hover': {
                        backgroundColor: 'rgba(37, 99, 235, 0.04)',
                      },
                    }}
                  >
                    Log Out
                  </Button>
                </>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </HideOnScroll>
  );
};

export default Navbar; 